import {MoneyRequest} from '@shipwell/settlements-sdk';

export * from './invoiceRuleConfigurationGuards';
export * from './freightSettlementsConfigurationGuards';

export const isMoneyRequest = (value: MoneyRequest | string): value is MoneyRequest =>
  typeof value !== 'string' && 'value' in value;
